<template>
  <div class="container mb-5 flex-row items-center gap-12 text-justify md:flex md:items-start">
    <div class="mb-5 w-full leading-relaxed md:w-1/2">
      <p class="mb-2 leading-relaxed">
        The Editor-in Chief Teresa Gialdroni thanks the Accademia Nazionale di S. Cecilia, the President Superintendent
        Michele dall'Ongaro, the head of scientific activities Renato Meucci for their support, and all the staff who
        have contributed professionally to achieving this result, in particular Cecilia Nanni and the editor Giacomo
        Sciommeri. We also thank the members of the scientific committee and the anonymous reviewers who have ensured
        that the published contributions conform to the highest possible level.
      </p>

      <p class="leading-relaxed">
        Studi Musicali is Accademia Nazionale di Santa Cecilia’s Journal dedicated to disciplines in the music sector
        and musicology. Founded in 1972 by Guido M. Gatti, it was run from 1977 to 1998 by Nino Pirotta, subsequently by
        Bruno Cagli and from 2001 to 2017 by Agostino Ziino.
      </p>
    </div>

    <div class="mb-5 w-full leading-relaxed md:w-1/2">
      <p class="leading-relaxed">
        The journal "Studi musicali" is pleased to present its new website and new access capabilities to its contents.
        Our periodical has inaugurated a new phase, introducing a revolutionary innovation that promises to radically
        transform the way readers interact with scientific knowledge: the ability to "dialogue" with articles thanks to
        artificial intelligence. Sophisticated algorithms make it possible to ask direct questions to the articles,
        request clarifications on specific passages, explore connections with other publications, and even obtain
        personalized summaries based on individual interests. This innovation not only democratizes access to knowledge,
        making it more understandable and usable even for a non-specialist audience, but also opens new perspectives for
        research itself, placing our journal at the forefront of the international scene.
      </p>
    </div>
  </div>
</template>
